module.exports = __webpack_public_path__ + "static/assets/e73eaa661b3f7bb257487afbf9c1858f.svg";